/**
 * Per click: a plain navigation to the download route, which re-checks access and redirects
 * to a short-lived URL. Nothing caches or stores that URL.
 */
export const downloadHref = (projectId: string, documentId: string) =>
  `/api/projects/${encodeURIComponent(projectId)}/documents/${encodeURIComponent(documentId)}/download`;

/**
 * Per click: the open route (PDF, PNG, JPEG), which re-checks access like download and
 * redirects to a short-lived URL that shows the file inline in a new tab.
 */
export const openHref = (projectId: string, documentId: string) =>
  `/api/projects/${encodeURIComponent(projectId)}/documents/${encodeURIComponent(documentId)}/open`;
